var map = {
	"./nopermiso/nopermiso.module": [
		"./src/app/nopermiso/nopermiso.module.ts",
		"nopermiso-nopermiso-module"
	],
	"./pages/administracion/administracion.module": [
		"./src/app/pages/administracion/administracion.module.ts",
		"common",
		"pages-administracion-administracion-module"
	],
	"./pages/catalogos/catalogo.module": [
		"./src/app/pages/catalogos/catalogo.module.ts",
		"default~pages-catalogos-catalogo-module~pages-proceso-proceso-module~pages-procesoTHD-proceso-thd-mo~6a04be8c",
		"common",
		"pages-catalogos-catalogo-module"
	],
	"./pages/cuenta/cuenta.module": [
		"./src/app/pages/cuenta/cuenta.module.ts",
		"common",
		"pages-cuenta-cuenta-module"
	],
	"./pages/dashboards/dashboard.module": [
		"./src/app/pages/dashboards/dashboard.module.ts",
		"pages-dashboards-dashboard-module"
	],
	"./pages/proceso/proceso.module": [
		"./src/app/pages/proceso/proceso.module.ts",
		"default~pages-catalogos-catalogo-module~pages-proceso-proceso-module~pages-procesoTHD-proceso-thd-mo~6a04be8c",
		"default~pages-proceso-proceso-module~pages-procesoTHD-proceso-thd-module",
		"common",
		"pages-proceso-proceso-module"
	],
	"./pages/procesoTHD/proceso.thd.module": [
		"./src/app/pages/procesoTHD/proceso.thd.module.ts",
		"default~pages-catalogos-catalogo-module~pages-proceso-proceso-module~pages-procesoTHD-proceso-thd-mo~6a04be8c",
		"default~pages-proceso-proceso-module~pages-procesoTHD-proceso-thd-module",
		"common",
		"pages-procesoTHD-proceso-thd-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;